import type { Prototype } from "../prototype-types";

export const artyomGabtraupovPrototypes: Prototype[] = [
  {
    id: "ag-slate-site-banner",
    name: "Slate Site Banner",
    path: "/ag/slate-site-banner",
    description:
      "Design Platform Spec for the Slate Site Banner component — multi-slide carousel, Neutral/Strong/Custom variants, anatomy, layout, a11y, motion, and research tabs.",
    owner: "Artyom Gabtraupov",
    project: "Slate Site Banner",
    createdAt: "2026-07-07",
    lastUpdated: "2026-10-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.faire.com/fastly/0c7d53b58f0115bf0aaeb81bf08b19b5d3fb7a8a07a1a7f2bd016d96d3a26b9f.png",
    creationTool: "claude-code",
  },
];
